import { voucher } from '@huggg/back-bar';
import AnalyticsService from 'services/AnalyticsService';
import initialStateLoader from '../initialState';

const analytics = new AnalyticsService();

const RESEND_DELAY_SECONDS = 60;

const RESEND = 'huggg/pin4/RESEND';
const RESENT = 'huggg/pin4/RESENT';
const CHANGE_DELAY = 'huggg/pin4/CHANGE_DELAY';
const RESEND_ERROR = 'huggg/pin4/RESEND_ERROR';
const CLEAR_ERROR = 'huggg/pin4/CLEAR_ERROR';

export const types = {
  CLEAR_ERROR,
  RESEND,
  RESENT,
  CHANGE_DELAY,
  RESEND_ERROR,
};

const startCountdown = (dispatch, sendTime, lastDelay) => {
  const now = new Date().getTime();
  const elapsedTime = Math.round((now - sendTime) / 1000);

  const delay =
    elapsedTime < RESEND_DELAY_SECONDS
      ? RESEND_DELAY_SECONDS - elapsedTime
      : null;

  // update state if the delay has changed
  if (delay !== lastDelay) {
    dispatch({ type: CHANGE_DELAY, payload: { delay } });
  }
  // check for more changes again if we're still delaying
  if (delay) {
    window.requestAnimationFrame(() =>
      startCountdown(dispatch, sendTime, delay),
    );
  }
};

const { pin4: initialState } = initialStateLoader();

/* Reducer - Default Export
========================================================================== */
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case RESEND:
      return { ...state, error: null, isSending: true };

    case RESEND_ERROR:
      return { ...state, error: payload.error, isSending: false };

    case RESENT:
      return {
        ...state,
        error: null,
        isSending: false,
      };

    case CHANGE_DELAY:
      return { ...state, resendDelay: payload.delay };

    default:
      return state;
  }
};

export default reducer;

/* Side Effects
========================================================================== */
export const resend = (hugggId) => (dispatch, getState) => {
  const { isSending } = getState().pin4;
  if (isSending) {
    return;
  }

  dispatch({ type: RESEND });

  return voucher
    .resendPin4(hugggId)
    .then(() => {
      dispatch({ type: RESENT });
      startCountdown(dispatch, new Date().getTime(), null);

      analytics.buttonClickResendPin4();
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }

      dispatch({
        type: RESEND_ERROR,
        payload: { error: err?.response?.data },
      });
    });
};

/* Selectors
========================================================================== */
export const getError = (state) => state.pin4.error;
export const getIsSending = (state) => state.pin4.isSending;
export const getResendDelay = (state) => state.pin4.resendDelay;

export const actions = {
  getError,
  getIsSending,
  getResendDelay,
  resend,
};
